import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Alerts from '../prototypes/Alerts';
import EditSectionDropdown from './EditSectionDropdown';
import EditSectionTextArea from './EditSectionTextArea';
import FileUpload from './FileUpload';


import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from './Dialog';


class FileUploadDialog extends React.Component{

  constructor( props ){
    super( props );
    this.state = {
      show: this.props.show === undefined ? false : this.props.show,
      currentitem: this.props.currentitem === undefined ? {} : this.props.currentitem,
      descriptionValue: this.props.descriptionValue === undefined ? '' : this.props.descriptionValue,
      defdnisValue: this.props.defdnisValue === undefined ? '' : this.props.defdnisValue,
      uploadtypeValue: 0,
      allfiles: this.props.allfiles === undefined ? [] : this.props.allfiles,
      optionstore: this.props.optionstore === undefined ? {} : this.props.optionstore,
      uploadfiles: this.props.uploadfiles === undefined ? {0:[], 1:[], 2:[]} : this.props.uploadfiles,
    };

    this.UPLOAD_TYPE_TFN = 0;
    this.UPLOAD_TYPE_OFF_NET = 1;
    this.UPLOAD_TYPE_ON_NET = 2;

    this.uploadtypeoptions = [
      { id: this.UPLOAD_TYPE_TFN, 'text': 'Leadgen TFN' },
      { id: this.UPLOAD_TYPE_OFF_NET, 'text': 'Off Net' },
      { id: this.UPLOAD_TYPE_ON_NET, 'text': 'On Net' }
    ];

    this.uploadKeySearch = {
      0: {'text': 'Leadgen TFN'},
      1: {'text': 'Off Net'},
      2: {'text': 'On Net'}
    };


    this.onChangeProgramDropdown = this.onChangeProgramDropdown.bind( this );
    this.onChangeUploadDropdown = this.onChangeUploadDropdown.bind( this );
    this.onDropFileUpload = this.onDropFileUpload.bind( this );
    this.onChangeTextArea = this.onChangeTextArea.bind( this );
    this.onConfirm = this.onConfirm.bind( this );
    this.onClose = this.onClose.bind( this );
  }

  componentWillReceiveProps( nextProps ){

    let pv_dropdown = nextProps.defdnisValue === undefined ? '' : nextProps.defdnisValue;
    if ( nextProps.defdnisValue === undefined || nextProps.defdnisValue === '' || nextProps.defdnisValue === null ){
      if ( nextProps.currentitem !== undefined ){
        if ( nextProps.currentitem.hasOwnProperty( 'DEFDNIS' ) ){
          pv_dropdown = nextProps.currentitem['DEFDNIS'];
        }
      }
    }

    let uploadfiles = nextProps.uploadfiles === undefined ? {0:[], 1:[], 2:[]} : this.cloneFileObj( nextProps.uploadfiles );
  
    this.setState( {
      currentitem: nextProps.currentitem === undefined ? {} : nextProps.currentitem,
      descriptionValue: nextProps.descriptionValue === undefined ? '' : nextProps.descriptionValue,
      defdnisValue: pv_dropdown,
      allfiles: nextProps.allfiles === undefined ? [] : nextProps.allfiles,
      show: nextProps.show,
      optionstore: nextProps.optionstore === undefined ? {} : nextProps.optionstore,
      uploadfiles: uploadfiles,
    } );

  }

  // Handles the file upload in this container instead of internally in the component and
  //   links all 3 containers together, allows for item interaction to happen to all FileUpload
  //   components. FileUpload communicates with this control by sending back an 'action' that
  //   then this function handles.
  //   [ e -- is sent from a FileUpload as {'action': str, files: array of files}
  onDropFileUpload( e ){

    // This is defined by every callback event returned in FileUpload
    if( e['action'] !== 'none' ){

      // e states
      let files = {};
      files = e['files'];
      let action = e['action'];
      let uploadT;
      let current_upload_files;
      let current_files;

      // global state
      let uploadFiles = this.cloneFileObj( this.state.uploadfiles );
      let all_file_names = [];
      let tmpUploadFiles = {0:[], 1:[], 2:[]};

      // Index variables
      let x;
      let i;

      // Adds files to the global state (changes)
      if( action === 'add' ){

        // Which of the 3 FileUpload components sent back the file
        uploadT = files[0]['upload_type'];

        // Assigning the correct 'upload_type'
        uploadFiles[uploadT] = files;

        // Flatting out the array and collecting all the filenames found in each of the upload_types
        for( i = 0; i < 3; i++ ) {
          // Assigning to current upload_type group
          current_upload_files = uploadFiles[i];
          for( x = 0; x < current_upload_files.length; x++ ) {
            let filename = current_upload_files[x]['name'];
            all_file_names.push( filename );
            tmpUploadFiles[i].push( current_upload_files[x] );
          }
        }

        // Updating the state (blocking files that have names in this list)
        this.setState( { allfiles: all_file_names, uploadfiles: uploadFiles } );

      // Removes files (on click event)
      } else {

        // If the length is 0, then the component has no more files to remove and is
        // returning an empty array -- this can happen if using only one FileUpload instead
        // of multiple ones (this edge case is handled here and the component will handle the
        // filtering)

        if( files.length !== 0 ){
          uploadT = files[0]['upload_type'];
          current_files = uploadFiles[uploadT];

          // New files
          let new_current = [];

          // Omitting the file on scan
          for( x = 0; x < current_files.length; x++ ) {
            if( files[0] !== current_files[x] ) {
              new_current.push( current_files[x] );
            }
          }

          // Assigning the new altered file
          uploadFiles[uploadT] = new_current;
        }

        // Recreating all the filenames from names found in each of the upload_types
        for( i = 0; i < 3; i++ ) {
          current_upload_files = uploadFiles[i];
          for( x = 0; x < current_upload_files.length; x++ ) {
            let filename = current_upload_files[x]['name'];
            all_file_names.push( filename );
            tmpUploadFiles[i].push( current_upload_files[x] );
          }
        }

        // Updating the state
        this.setState( { allfiles: all_file_names, uploadfiles: uploadFiles } );
      }
    }
  }

  //In order to preserve the state of uploadfiles for this component,
  //we need to create a custom clone of the object
  //This is so we do not unintentionally pass around references to components
  //and to keep this component's variable exclusive to this component
  cloneFileObj( obj ){
    let files = null;
    let newObj = {0:[],1:[],2:[]};
    for( var i = 0; i < 3; i++ ){
      files = obj[i];
      for( var j = 0; j < files.length; j++ ){
        newObj[i].push( files[j] );
      }
    }
    return newObj;
  }


  // Return an array with additional information regarding all uploaded files
  formatFilesTextArea( uploadFiles ){
    let rdArr = [];
    let current_upload_files = null;
    let filename = null;
    let defdnis = null;
    for( let i = 0; i < 3; i++ ) {
      current_upload_files = uploadFiles[i];
      for( let x = 0; x < current_upload_files.length; x++ ) {
        filename = current_upload_files[x]['name'];
        defdnis = current_upload_files[x]['defdnis'];
        rdArr.push( filename + ' (' + this.uploadKeySearch[i].text + ' - ' + defdnis + ')' );
      }
    }
    return rdArr;
  }

  onChangeProgramDropdown( e ){
    this.setState( { defdnisValue: e.target.value} );
  }

  onChangeUploadDropdown( e ){
    this.setState( { uploadtypeValue: parseInt( e.target.value, 10 )} );
  }

  onChangeTextArea( e ){
    this.setState( { descriptionValue: e.target.value} );
  }

  onConfirm( e ){
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    const alerts = new Alerts( Bugsnag, dispatch );
    let filelistinfo = this.cloneFileObj( this.state.uploadfiles );
    if ( this.props.onConfirm !== undefined ){
      let dialoginfo = {
        'defdnis': this.state.defdnisValue,
        'uploadtype': this.state.uploadtypeValue,
        'description': this.state.descriptionValue,
        'filelist': this.state.allfiles,
        'filelistinfo': filelistinfo,
      };

      alerts.SUCCESS( 'File Upload', 'File Upload Information Saved', 3000 );
      this.props.onConfirm( dialoginfo );

    }
  }

  onClose( e ){
    if ( this.props.onCancel !== undefined ){
      this.props.onCancel( e );
    }
  }

  renderFilesTextArea(){
    let textareaString = '';
    let rdArr = [];
    rdArr = this.formatFilesTextArea( this.state.uploadfiles );
    for( let i = 0; i < rdArr.length; i++ ){
      textareaString += rdArr[i] + '\n';
    }
    return(
      <div style={{'width':'50%'}}>
        <textarea id={'file_upload_leadgen_a_key'} style={{'width':'100%','height':'100%','resize':'none'}} disabled value={textareaString} >
        </textarea>
      </div>
    );
  }

  renderFileUpload( visibility,uploadType,groupName ){
    let varVisibility = 'none';
    if ( visibility === 1 ){
      varVisibility = 'block';
    } else {
      varVisibility = 'none';
    }

    return(
      <span style={{'width':'50%','display': varVisibility}}>
        <FileUpload
          // Styles
          dropZoneStyleClass='fileupload-view'
          containerStyle='fileupload-container'
          containerStyleAfter='fileupload-container-after'
          text_style='fileupload-text'
          viewTextStyle='fileupload-text-view'

          // Attributes and args
          id={'file_upload_id_dropzone_' + uploadType.toString()}
          group_name={groupName} 
          defdnis={this.state.defdnisValue} 
          description={this.state.descriptionValue} 
          upload_type={uploadType} 
          globalList={this.state.allfiles} 
          files={this.state.uploadfiles[uploadType]}
          onDropFile={this.onDropFileUpload}
          width="100%"/>
      </span>
    );
  }

  renderBody(){
    let dialogbody = '';
    let group_name = '';
    let newData = [];
    let pv_dropdown = this.state.defdnisValue;

    let optionstore = this.state.optionstore;
    if ( optionstore !== undefined ){
      if ( optionstore.hasOwnProperty( 'dnislist' ) ){
        newData = optionstore['dnislist'];
      }
    }

    let showTFN = 0;
    let showOffNet = 0;
    let showOnNet = 0;
    let uploadType = this.state.uploadtypeValue;

    switch( uploadType ){
    case 0:
      showTFN = 1;
      showOffNet = 0;
      showOnNet = 0;
      break;
    case 1:
      showTFN = 0;
      showOffNet = 1;
      showOnNet = 0;
      break;
    case 2:
      showTFN = 0;
      showOffNet = 0;
      showOnNet = 1;
      break;
    default:
      showTFN = 1;
      showOffNet = 0;
      showOnNet = 0;
      break;
    }

    dialogbody = (
      <div key={'detail_view_row_file_upload_key'} style={{'height':'inherit'}}>
        <div style={{'width':'100%','display': 'flex','marginBottom':'1%'}}>
          <div style={{'width':'25%'}}>
            <div className='detail-view-content-label'>{'Select Upload Type:'}</div>
          </div>
          <div style={{'width':'30%'}}>
            <EditSectionDropdown id={'file_upload_leadgen_dropdown_u_key'} value={this.state.uploadtypeValue} options={this.uploadtypeoptions} width="70%" onChanged={this.onChangeUploadDropdown} />
          </div>
        </div>
        <div style={{'width':'100%','display': 'flex','marginBottom':'1%'}}>
          <div style={{'width':'25%'}}>
            <div className='detail-view-content-label'>{'Select Default DNIS:'}</div>
          </div>
          <div style={{'width':'30%'}}>
            <EditSectionDropdown id={'file_upload_leadgen_dropdown_p_key'} value={pv_dropdown} options={newData} width="70%" onChanged={this.onChangeProgramDropdown} />
          </div>
        </div>
        <div style={{'width':'100%','display': 'flex','height':'25%','marginBottom':'1%'}}>
          <div style={{'width':'25%'}}>
            <div className='detail-view-content-label'>{'Description:'}</div>
          </div>
          <div style={{'width':'50%'}}>
            <EditSectionTextArea id={'file_upload_leadgen_dropdown_d_key'} value={this.state.descriptionValue} width="100%" height="100%" onChanged={this.onChangeTextArea} />
          </div>
        </div>
        <div style={{'width':'100%','display': 'flex','height':'25%','marginBottom':'1%'}} key={'fileupload_dropzone_key'}>
          <span style={{'width':'25%'}}>
            <span className='detail-view-content-label'>{'Upload Your Files Here:'}</span>
          </span>
          {this.renderFileUpload( showTFN,0,group_name )}
          {this.renderFileUpload( showOffNet,1,group_name )}
          {this.renderFileUpload( showOnNet,2,group_name )}
        </div>
        <div style={{'width':'100%','display': 'flex','height':'25%','marginBottom':'1%'}}>
          <div style={{'width':'25%'}}>
            <div className='detail-view-content-label'>{'All Uploaded Files:'}</div>
          </div>
          {this.renderFilesTextArea()}
        </div>
      </div>              

    );          

    return(
      <div style={{'height':'100%', 'padding':'2%'}}>
        {dialogbody}
      </div>
    );
  }


  renderModal(){
    let width = 40;
    let height = 60;
    return (
      <div>
        <Dialog width={width} height={height} show={this.state.show} >
          <DialogHeader caption={'Upload A New File'} closeButton onClose={this.onClose} />
          <DialogBody className={'dialog-body'}>
            {this.renderBody()}
          </DialogBody>
          <DialogFooter className={'dialog-footer'}>
            <button className='file-upload-dialog-cancel-button' style={{'fontSize':'10pt'}} key='btnCancel' onClick={this.onClose}>CANCEL</button>
            <button className='file-upload-dialog-confirm-button' style={{'fontSize':'10pt'}} key='btnConfirm' onClick={this.onConfirm}>CONFIRM</button>
          </DialogFooter>
        </Dialog>
      </div>
    );
  }


  render(){
    return (
      <div className='leadgen-dialog'>
        {this.renderModal()}
      </div>
    );
  }

}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( FileUploadDialog ) );



// WEBPACK FOOTER //
// ./src/presentation/FileUploadDialog.js